import { gql } from '@apollo/client';

// Device-troubleshoot history surface (read-only list + transcript) + resume.
// Backed by open-api's device/staff resolvers, which proxy device-agent-api over mTLS. The LIVE session
// (SSE + approve) does NOT go through GraphQL — the browser talks to device-agent-api directly with the
// per-session capability token returned by open + resume (see useDeviceSessionStream).

/** The account's troubleshooting sessions (most-recent first), optionally filtered to one device. */
export const DEVICE_TROUBLESHOOT_SESSIONS_QUERY = gql`
  query DeviceTroubleshootSessions($deviceUuid: String) {
    deviceTroubleshootSessions(deviceUuid: $deviceUuid) {
      sessionId
      deviceUUID
      deviceId
      deviceName
      title
      teamId
      actor
      mode
      status
      region
      startedAt
      endedAt
      threadId
    }
  }
`;

/** Recorded transcript events for one session (redacted server-side). Returns a JSON-scalar array whose
 *  shape matches useDeviceSessionStream's SessionEvent — fed straight into the view as initialEvents. */
export const DEVICE_TROUBLESHOOT_TRANSCRIPT_QUERY = gql`
  query DeviceTroubleshootSessionTranscript($sessionId: String!) {
    deviceTroubleshootSessionTranscript(sessionId: $sessionId)
  }
`;

/** Resume a past session: device-agent-api boots a fresh runner with the rehydrated context and
 *  re-mints a browser capability token. Returns the live handle (sessionId/sessionToken/streamUrl). */
export const RESUME_DEVICE_TROUBLESHOOT_SESSION = gql`
  mutation ResumeDeviceTroubleshootSession($sessionId: String!, $deviceUuid: String!) {
    resumeDeviceTroubleshootSession(sessionId: $sessionId, deviceUuid: $deviceUuid) {
      sessionId
      sessionToken
      streamUrl
      deviceName
      title
    }
  }
`;

export const START_DEVICE_TROUBLESHOOT_SESSION = gql`
  mutation StartDeviceTroubleshootSession($deviceId: String!, $task: String, $title: String) {
    startDeviceTroubleshootSession(deviceId: $deviceId, task: $task, title: $title) {
      sessionId
      sessionToken
      streamUrl
      deviceName
      title
    }
  }
`;
